<template>
  <div>
    <filtroExtrato @filtro="makeFiltro"></filtroExtrato>
    <ListExtrato
      :subjectPermission="subjectPermission"
      :filtro="filtro"
      :realizarFiltro="realizarFiltro"
      @finalizarFiltro="finalizarFiltro"
    />
  </div>
</template>

<script>
import ListExtrato from '../../lists/ListExtrato.vue';
import filtroExtrato from '../../filtros/FiltroExtrato.vue';

export default {
  name: 'extrato-page',
  data() {
    return {
      subjectPermission: 'Extrato',
      realizarFiltro: false,
      filtro: null,
    };
  },
  methods: {
    makeFiltro(filtro) {
      this.realizarFiltro = true;
      this.filtro = filtro;
    },
    finalizarFiltro() {
      this.realizarFiltro = false;
    },
  },
  watch: {},
  created() {},
  components: {
    ListExtrato,
    filtroExtrato,
  },
};
</script>
